<template>
	<div class="home">
		<h2 class="home-title">Welcome {{ userName }}</h2>
		<HomeCard
			title="Start a New Job"
			button="Start New Job"
			description="Please supply as many relevant job details as you are able on the following page"
			path="booking-number"
			v-if="isClient"
		/>
		<HomeCard
			title="Manage Your Jobs"
			button="List Your Jobs"
			description="View current and previous work history."
			path="job-list"
		/>
	</div>
</template>

<script>
import HomeCard from '@/components/HomeCard.vue'

export default {
	name: 'home',
	data() {
		return {
			user: JSON.parse(sessionStorage.user)
		}
	},
	computed: {
		userName() {
			return this.user.name
		},
		isClient() {
			const profile = this.user.profile
			return profile === 'Client'
		}
	},
	components: {
		HomeCard
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/views/home.scss';
</style>
